const password = {
    unsupported_encryption_method: 'O método de enncriptação {{name}} não é suportado.',
    pepper_not_found: 'pepper da Password não encontrada. Por favor, verifique os envs.',
};
export default password;
